import React from "react";

export const AppleTVIconV2 = ({
  opacity,
  width,
  height,
  extraClasses = "",
  fill = "#212121",
}) => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20.3 12.47"
        fill="currentColor"
        width={width || "100%"}
        height={height || "100%"}
      >
        <path d="m6.21,1.16c.06.6-.18,1.19-.53,1.63-.37.43-.95.76-1.53.71-.08-.58.21-1.19.54-1.56.37-.44,1-.75,1.52-.78Z" />
        <path d="m4.84,3.91c.38-.15.84-.33,1.36-.3.33.02,1.27.12,1.88,1.01,0,0,0,0-.02.01-.16.1-1.1.71-1.09,1.92.01,1.44,1.2,1.98,1.36,2.05.01,0,.02,0,.02,0,0,0,0,0,0,.01-.03.1-.24.75-.7,1.42-.43.62-.87,1.24-1.57,1.25-.33,0-.56-.09-.79-.19-.24-.1-.5-.21-.9-.21s-.69.11-.94.22c-.22.09-.44.18-.73.19-.68.02-1.2-.66-1.62-1.29C.19,8.76-.47,6.47.43,4.92c.44-.77,1.25-1.26,2.12-1.27.38,0,.74.14,1.06.26.24.09.45.18.63.18.16,0,.36-.08.61-.18Z" />
        <path d="m11.58,4.12v-1.69h-1.42s0,1.69,0,1.69h-1.05v1.12h1.05v4.13c0,1.37.55,1.91,1.98,1.91.32,0,.65-.03.81-.06v-1.13c-.1.01-.34.03-.49.03-.6,0-.88-.28-.88-.9v-3.99h1.38v-1.12h-1.38Z" />
        <path d="m16.26,11.22h1.51l2.53-7.1h-1.48l-1.78,5.71h-.03l-1.78-5.71h-1.5l2.54,7.1Z" />
      </svg>
    </span>
  );
};

export const AppleTVIcon = ({
  opacity,
  width,
  height,
  extraClasses = "",
  fill = "#212121",
}) => {
  return (
    <span role="img" className={extraClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "100%"}
        height={height || "100%"}
        viewBox="0 0 21 10"
        fill="none"
      >
        <g opacity={opacity || 0.4}>
          <path
            d="M6.14174 0C6.20421 0.591873 5.96698 1.17113 5.61708 1.6026C5.25451 2.02196 4.68005 2.35437 4.10508 2.30515C4.03006 1.73814 4.31774 1.13453 4.64254 0.764765C5.00447 0.333165 5.62963 0.0251136 6.14174 0Z"
            fill={fill}
          />
          <path
            d="M4.79225 2.71039C5.16572 2.56535 5.62732 2.38609 6.13521 2.41595C6.45924 2.44056 7.39397 2.539 7.99211 3.41103C7.98909 3.4133 7.98235 3.41765 7.97237 3.4241C7.81774 3.52398 6.88377 4.12726 6.89556 5.31625C6.90721 6.73427 8.0811 7.26573 8.23678 7.33622C8.24705 7.34087 8.25367 7.34427 8.25367 7.34427C8.25302 7.3462 8.25187 7.34985 8.2502 7.35512C8.21972 7.45166 8.01697 8.09385 7.55605 8.7577C7.13241 9.37241 6.69597 9.97476 5.99822 9.987C5.66969 9.99304 5.44804 9.89942 5.2174 9.802C4.97554 9.69985 4.72378 9.59351 4.32849 9.59351C3.91394 9.59351 3.65005 9.70326 3.39631 9.8088C3.17713 9.89995 2.96552 9.98796 2.67093 9.99937C1.99802 10.0236 1.48744 9.3473 1.06368 8.73309C0.191044 7.49154 -0.469319 5.23056 0.427894 3.70608C0.864082 2.94409 1.66182 2.46504 2.52139 2.45267C2.89671 2.44586 3.25592 2.58575 3.56935 2.70782C3.80749 2.80056 4.01921 2.88301 4.1915 2.88301C4.34773 2.88301 4.55171 2.8038 4.79225 2.71039Z"
            fill={fill}
          />
          <path
            d="M11.4532 2.92063V1.25102L10.0441 1.2509V2.92051H9.00071V4.02248H10.0441V8.08961C10.0441 9.43855 10.5929 9.97288 12.002 9.97288C12.3204 9.97288 12.6456 9.94612 12.8082 9.91268V8.80415C12.7132 8.81753 12.4695 8.83759 12.3204 8.83759C11.7244 8.83759 11.4533 8.55705 11.4533 7.94928V4.02235H12.8149V2.92063H11.4532Z"
            fill={fill}
          />
          <path
            d="M16.0857 9.91798H17.5811L20.0827 2.92152H18.6212L16.8571 8.54405H16.8233L15.0592 2.92152H13.5706L16.0857 9.91798Z"
            fill={fill}
          />
        </g>
      </svg>
    </span>
  );
};
